// src/index.js
import React, { Suspense, useState } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import Loading from "./Loading";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import Store from "./store";
import { BrowserRouter as Router } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./AuthConfig";
import LandingPage from "./pages/LandingPage";
import { useMsal } from "@azure/msal-react";

const msalInstance = new PublicClientApplication(msalConfig);

function Root() {
  const [flag, setFlag] = useState(() => {
    return Boolean(sessionStorage.getItem("internalAppTarget"));
  });
  // console.log("flagflagflag", flag, msalInstance);
  // const { accounts } = useMsal();
  // console.log("accounts", accounts);
  return (
    <Provider store={Store}>
      <Suspense fallback={<Loading />}>
        <Router>
          {!flag ? (
            // Pass setFlag down so LandingPage can flip to App shell
            <LandingPage setFlag={setFlag} />
          ) : (
            <App instance={msalInstance} />
          )}
        </Router>
      </Suspense>
    </Provider>
  );
}

const root = createRoot(document.getElementById("root"));
root.render(<Root />);
reportWebVitals();
